import { Injectable } from '@angular/core';
import { Usuario } from '@tivic-team/manager-ts/dist/seg/entities/usuario.entity';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  get usuario(): Usuario {
    try {
        if (localStorage.getItem('usuario'))
            return JSON.parse(localStorage.getItem('usuario'));
        else
            return null;
    } catch (e) {
        console.log(e);
    }
}

  setValue(name: string, value: any): void {
    localStorage.setItem(name, value);
  }

  getValue(name: any): any {
    return localStorage.getItem(name);
  }
  
  removeValue(name: any): any {
    return localStorage.removeItem(name);
  }
}
